import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/icon/warning.png'


const _hoisted_1 = { class: "title flex-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "flex-end-ter" }

import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import { thirdUnbind } from '@/apis/user'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: ['visible', 'rowItem'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: emits }) {

const props = __props


const store = useStore()
const editableTabs = store.state.bussiness.Shops
const platName = ref()
watch(() => props.visible, (newValue) => {
  if (newValue) {
    const idx = editableTabs.findIndex((e: any) => e.value === props.rowItem.customerShopPlatform)
    platName.value = idx > -1 ? editableTabs[idx].label : ''
  }
})
const ok = () => {
  thirdUnbind({
    customerShopId: props.rowItem.customerShopId,
    customerShopName: props.rowItem.customerShopName,
    thirdShopType: props.rowItem.customerShopPlatform
  }).then(res => {
    if (res.success) {
      ElMessage.success(t('解绑成功'))
      emits('success')
      emits('update:visible')
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "cancelAuthorizedVisible",
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_1, [
          _hoisted_2,
          _createTextVNode(_toDisplayString(_unref(t)('提示')), 1)
        ]),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？').replace('xxx', platName.value ? _unref(t)(platName.value) : "")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('否')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: ok
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('是')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})